import { BaseIntegration } from 'libs/end-to-end/src/types/databases/integrations/base-integration';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { z } from 'zod';

export const SqlServerIntegrationTable = z.object({
  tableName: z.string(),
  schemaName: z.string().optional(),
  database: z.string().optional(),
});

export type SqlServerIntegrationTable = z.infer<
  typeof SqlServerIntegrationTable
>;

export const SqlServerIntegrationQuery = z.object({
  name: z.string(),
  query: z.string(),
  database: z.string().optional(),
});

export type SqlServerIntegrationQuery = z.infer<
  typeof SqlServerIntegrationQuery
>;

export const SqlServerIntegration = BaseIntegration.extend({
  integrationType: z.literal('SqlServer'),
  host: z.string(),
  port: z.number(),
  user: SecretReference.optional(),
  password: SecretReference.optional(),
  tables: SqlServerIntegrationTable.array(),
  queries: SqlServerIntegrationQuery.array().optional(),
  requestTimeoutInSeconds: z.number().optional(),
});

export type SqlServerIntegration = z.infer<typeof SqlServerIntegration>;
